export interface Review {
  author: string;
  date: string;
  score: number;
  excerpt: string;
}

export interface Movie {
  id: string;
  title: string;
  type: "movie" | "tv";
  genres: string[];
  region: string;
  year: number;
  rating: number;
  cover: string;
  tagline: string;
  synopsis: string;
  director: string;
  cast: string[];
  status: string;
  length: string;
  updatedAt: string;
  reviews: Review[];
}

export const movies: Movie[] = [
  {
    id: "long-night-coming",
    title: "长夜将尽",
    type: "movie",
    genres: ["犯罪", "悬疑", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20of%20a%20lone%20silhouette%20walking%20through%20a%20rain%20soaked%20neon%20alley%20at%20night%2C%20deep%20navy%20blue%20tones%20with%20a%20single%20warm%20orange%20streetlight%2C%20fog%2C%20film%20noir%20atmosphere%2C%20minimal%20negative%20space%2C%20stylized%20artistic%20illustration&width=600&height=900&seq=marie-poster-01&orientation=portrait",
    tagline: "每一个谎言，都在深夜等待天亮。",
    synopsis: "一桩尘封十七年的旧案重新浮出水面，前刑警与年轻记者在雨夜的城市里追查真相。越靠近答案，他们越发现所谓正义与私心只隔着一层薄雾。",
    director: "陈砚舟",
    cast: ["林知远", "苏晚", "周维西", "高伯远"],
    status: "正片可观看 · 高清",
    length: "128 分钟",
    updatedAt: "2026-09-28",
    reviews: [
      {
        author: "影志小编",
        date: "2026-09-30",
        score: 8.8,
        excerpt: "导演用一种近乎克制的耐心，把悬疑拍成了关于记忆的挽歌。雨夜、霓虹与沉默的对话，让整部影片像一场缓慢而坚定的追问。",
      },
      {
        author: "夜航评论",
        date: "2026-10-02",
        score: 8.4,
        excerpt: "林知远贡献了近年最好的表演，几个长镜头里的迟疑与颤抖，比任何台词都更有力量。",
      },
    ],
  },
  {
    id: "star-sea-dream",
    title: "星海遗梦",
    type: "movie",
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2025,
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20of%20a%20lone%20astronaut%20floating%20before%20a%20giant%20glowing%20planet%20ring%2C%20deep%20navy%20space%20background%20with%20orange%20nebula%20glow%2C%20minimal%20composition%2C%20epic%20and%20hopeful%20mood%2C%20stylized%20artistic%20illustration&width=600&height=900&seq=marie-poster-02&orientation=portrait",
    tagline: "我们失去的，终将在星光里重逢。",
    synopsis: "一支深空考察队抵达人类最后的移民候选星球，却发现那里保持着一段不属于他们的记忆。为了回家，他们必须先弄明白：究竟是谁把梦境寄到了星海尽头。",
    director: "Damon Reeve",
    cast: ["Elena Frost", "Marcus Hale", "Nina Okafor"],
    status: "正片可观看 · 4K",
    length: "146 分钟",
    updatedAt: "2026-09-25",
    reviews: [
      {
        author: "科幻观察",
        date: "2026-09-27",
        score: 8.5,
        excerpt: "在硬核设定之下，它其实讲的是一个关于告别的故事。最后一幕的静默，比任何爆炸都更震撼。",
      },
    ],
  },
  {
    id: "spring-echo",
    title: "春日回声",
    type: "tv",
    genres: ["爱情", "剧情", "都市"],
    region: "韩国",
    year: 2023,
    rating: 7.9,
    cover: "https://readdy.ai/api/search-image?query=Warm%20romantic%20TV%20drama%20poster%20of%20two%20figures%20standing%20apart%20under%20blooming%20cherry%20blossoms%20in%20soft%20spring%20light%2C%20muted%20cream%20and%20dusty%20orange%20palette%2C%20gentle%20melancholic%20atmosphere%2C%20minimal%20elegant%20composition%2C%20stylized%20illustration&width=600&height=900&seq=marie-poster-03&orientation=portrait",
    tagline: "有些告别，是一句迟到了十年的回答。",
    synopsis: "电台主播与旧日恋人在同一座城市重逢，一个负责播报别人的故事，一个负责修复别人的房子。他们小心翼翼地靠近，却始终绕不开那年春天没能说完的话。",
    director: "金度允",
    cast: ["韩素伊", "朴志勋", "李在民"],
    status: "全 16 集 · 已完结",
    length: "16 集",
    updatedAt: "2026-09-20",
    reviews: [
      {
        author: "追剧指南",
        date: "2026-09-21",
        score: 8.0,
        excerpt: "韩剧最擅长的细腻在这里被拿捏得恰到好处，没有大起大落，却让人一集接一集地看下去。",
      },
    ],
  },
  {
    id: "city-of-masks",
    title: "千面之城",
    type: "movie",
    genres: ["悬疑", "惊悚", "犯罪"],
    region: "英国",
    year: 2024,
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20film%20poster%20of%20a%20crowd%20of%20faceless%20figures%20in%20long%20coats%20under%20dim%20foggy%20city%20lights%2C%20desaturated%20navy%20and%20grey%20tones%20with%20a%20single%20orange%20spotlight%2C%20tense%20uncanny%20mood%2C%20minimal%20stylized%20composition&width=600&height=900&seq=marie-poster-04&orientation=portrait",
    tagline: "在这座城里，没有人以真面目行走。",
    synopsis: "一名身份成谜的鉴证专家接手连环案件，每一名受害者都戴着不同的人皮面具。当线索指向他自己时，他开始怀疑自己是否也早已换了张脸。",
    director: "Harriet Cole",
    cast: ["Oliver Grant", "Sofia Marlow", "Daniel Kent"],
    status: "正片可观看 · 高清",
    length: "134 分钟",
    updatedAt: "2026-09-18",
    reviews: [
      {
        author: "悬疑片观察室",
        date: "2026-09-19",
        score: 8.1,
        excerpt: "结构精巧，反转不靠惊吓而靠逻辑。英式冷峻的镜头语言把观众一步步逼进主角的偏执里。",
      },
    ],
  },
  {
    id: "mist-harbor",
    title: "雾港之谜",
    type: "tv",
    genres: ["犯罪", "悬疑", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20crime%20series%20poster%20of%20a%20fishing%20harbor%20shrouded%20in%20thick%20morning%20mist%20with%20a%20solitary%20lit%20lamp%20post%2C%20cold%20navy%20blue%20and%20faded%20orange%20tones%2C%20quiet%20ominous%20mood%2C%20cinematic%20minimal%20illustration&width=600&height=900&seq=marie-poster-05&orientation=portrait",
    tagline: "潮水退去时，秘密才会露出礁石。",
    synopsis: "南方小港连续出现无名浮尸，退休海警与年轻法医联手追查，牵出一张横跨二十年的走私网络。海雾散尽之前，没有人是清白的旁观者。",
    director: "罗启铭",
    cast: ["曾亦辰", "白露", "许承业"],
    status: "全 24 集 · 已完结",
    length: "24 集",
    updatedAt: "2026-09-16",
    reviews: [
      {
        author: "剧评人·老K",
        date: "2026-09-18",
        score: 8.6,
        excerpt: "近年少见的扎实群像刑侦剧，节奏稳、细节密，配角个个有血有肉。港口的雾气几乎成了第三个主角。",
      },
    ],
  },
  {
    id: "tokyo-fireworks",
    title: "东京烟火",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "日本",
    year: 2022,
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20film%20poster%20of%20a%20small%20old%20couple%20watching%20summer%20fireworks%20over%20a%20quiet%20japanese%20town%20at%20dusk%2C%20gentle%20orange%20and%20deep%20indigo%20palette%2C%20nostalgic%20tender%20mood%2C%20minimal%20elegant%20composition%2C%20stylized%20illustration&width=600&height=900&seq=marie-poster-06&orientation=portrait",
    tagline: "有些爱，藏在没说出口的每一天里。",
    synopsis: "经营了四十年的老烟花铺即将拆迁，固执的父亲与多年未归的女儿在最后一个夏天重新学着相处。一场烟火，照亮了一个家庭所有的倔强与柔软。",
    director: "佐藤绫子",
    cast: ["小林重雄", "田中晴美", "山本悠真"],
    status: "正片可观看 · 高清",
    length: "118 分钟",
    updatedAt: "2026-09-12",
    reviews: [
      {
        author: "日影笔记",
        date: "2026-09-14",
        score: 9.0,
        excerpt: "克制到近乎沉默的表演，却在结尾的烟花里一次性倾泻。看完在座位上坐了很久。",
      },
    ],
  },
  {
    id: "wasteland-courier",
    title: "荒原信使",
    type: "movie",
    genres: ["科幻", "灾难", "动作"],
    region: "美国",
    year: 2023,
    rating: 7.5,
    cover: "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci%20fi%20poster%20of%20a%20lone%20courier%20in%20a%20dust%20cloak%20crossing%20a%20vast%20orange%20desert%20wasteland%20under%20a%20grey%20sky%2C%20ruined%20skyscrapers%20in%20distance%2C%20gritty%20atmospheric%20mood%2C%20minimal%20stylized%20cinematic%20illustration&width=600&height=900&seq=marie-poster-07&orientation=portrait",
    tagline: "世界尽头，还有一封信值得送达。",
    synopsis: "大停电后的第十年，最后一位信使肩负着一封能重启广播塔的信件穿越荒原。沿途的每个幸存者营地，都在考验他是否还相信文明值得被拯救。",
    director: "Jonah Pike",
    cast: ["Chris Vaughn", "Adele Moretti"],
    status: "正片可观看 · 高清",
    length: "121 分钟",
    updatedAt: "2026-09-10",
    reviews: [
      {
        author: "类型片档案",
        date: "2026-09-11",
        score: 7.6,
        excerpt: "世界观设定很有野心，中段略显拖沓，但结局那段无线电重连的戏份值得票价。",
      },
    ],
  },
  {
    id: "glass-garden",
    title: "玻璃花园",
    type: "tv",
    genres: ["都市", "情感", "职场"],
    region: "中国大陆",
    year: 2024,
    rating: 7.2,
    cover: "https://readdy.ai/api/search-image?query=Contemporary%20urban%20drama%20poster%20of%20a%20young%20woman%20looking%20out%20from%20behind%20a%20rain%20streaked%20glass%20wall%20of%20a%20modern%20office%2C%20cool%20navy%20tones%20with%20soft%20orange%20highlight%2C%20introspective%20modern%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-08&orientation=portrait",
    tagline: "我们都住在自己的玻璃花园里。",
    synopsis: "三位性格迥异的都市女性在同一家公司相遇，在升职、感情与家庭之间努力保持体面。玻璃幕墙外的世界很亮，玻璃幕墙内的她们却常常看不清自己。",
    director: "邵雨桐",
    cast: ["沈芷晴", "赵一帆", "梁思允"],
    status: "全 32 集 · 已完结",
    length: "32 集",
    updatedAt: "2026-09-08",
    reviews: [
      {
        author: "都市剧观察",
        date: "2026-09-09",
        score: 7.3,
        excerpt: "话题抓得准，职场细节真实，只是后半程略显套路，好在表演撑住了。",
      },
    ],
  },
  {
    id: "last-metro-paris",
    title: "巴黎最后一班地铁",
    type: "movie",
    genres: ["爱情", "文艺", "剧情"],
    region: "法国",
    year: 2021,
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20arthouse%20film%20poster%20of%20two%20strangers%20sitting%20at%20opposite%20ends%20of%20an%20empty%20paris%20metro%20carriage%20at%20night%2C%20warm%20amber%20light%20against%20deep%20navy%20shadows%2C%20melancholic%20tender%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-09&orientation=portrait",
    tagline: "有些人，只在末班车上遇见一次。",
    synopsis: "一个失意的调香师和一个即将离开巴黎的提琴手，在一趟又一趟末班地铁里交换秘密。他们都清楚这段关系有终点，却依然愿意为彼此多坐一站。",
    director: "Élise Marchand",
    cast: ["Julien Roche", "Camille Dubois"],
    status: "正片可观看 · 高清",
    length: "105 分钟",
    updatedAt: "2026-09-06",
    reviews: [
      {
        author: "文艺片手记",
        date: "2026-09-07",
        score: 8.4,
        excerpt: "台词写得像诗却不做作，光影把巴黎拍成了一封没寄出的情书。适合一个人安静地看。",
      },
    ],
  },
  {
    id: "deep-blue-echo",
    title: "深蓝回响",
    type: "tv",
    genres: ["科幻", "悬疑", "惊悚"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20thriller%20series%20poster%20of%20a%20deep%20sea%20research%20station%20glowing%20under%20dark%20ocean%20water%2C%20bioluminescent%20orange%20particles%20around%20it%2C%20overwhelming%20deep%20navy%20abyss%2C%20eerie%20mysterious%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-10&orientation=portrait",
    tagline: "海底的信号，比宇宙更遥远。",
    synopsis: "深海研究站收到一段来自海沟深处的重复信号，内容是他们自己三小时后的对话。随着时间线不断重叠，站员们开始恐惧——也许出口从来就不存在。",
    director: "Grace Holloway",
    cast: ["Tessa Blaine", "Ryan Cole", "Amara Singh"],
    status: "全 10 集 · 已完结",
    length: "10 集",
    updatedAt: "2026-09-04",
    reviews: [
      {
        author: "硬核科幻谈",
        date: "2026-09-05",
        score: 8.9,
        excerpt: "把密闭空间、时间循环和人性压力揉在一起的教科书级范例。前两集慢热，第三集起直接起飞。",
      },
    ],
  },
  {
    id: "mountain-sea-scroll",
    title: "山海绘卷",
    type: "movie",
    genres: ["奇幻", "动画", "冒险"],
    region: "中国大陆",
    year: 2024,
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20film%20poster%20of%20a%20giant%20elegant%20mythical%20beast%20coiling%20around%20misty%20mountain%20peaks%2C%20ink%20painting%20style%20with%20deep%20navy%20and%20vivid%20orange%20accents%2C%20ethereal%20epic%20mood%2C%20ornate%20minimal%20composition&width=600&height=900&seq=marie-poster-11&orientation=portrait",
    tagline: "一卷未完成的画，藏着整个山海。",
    synopsis: "少女画师意外进入家族流传的神秘画卷，画卷里的神兽正因笔墨褪色而逐渐消失。为了带它们回家，她必须在画卷彻底合上之前补完那个被抹去的结局。",
    director: "陆青禾",
    cast: ["配音 · 顾清歌", "配音 · 谢云归"],
    status: "正片可观看 · 4K",
    length: "112 分钟",
    updatedAt: "2026-09-02",
    reviews: [
      {
        author: "国漫观察站",
        date: "2026-09-03",
        score: 9.1,
        excerpt: "水墨美学的天花板之一，每一帧都能截图当壁纸，故事同样扎实不敷衍。",
      },
    ],
  },
  {
    id: "against-light",
    title: "逆光而行",
    type: "movie",
    genres: ["剧情", "励志", "运动"],
    region: "中国大陆",
    year: 2023,
    rating: 7.8,
    cover: "https://readdy.ai/api/search-image?query=Inspirational%20sports%20drama%20poster%20of%20a%20runner%20silhouette%20sprinting%20toward%20a%20huge%20low%20sun%20on%20an%20empty%20track%2C%20warm%20orange%20backlight%20against%20deep%20navy%20sky%2C%20determined%20hopeful%20mood%2C%20minimal%20stylized%20cinematic%20illustration&width=600&height=900&seq=marie-poster-12&orientation=portrait",
    tagline: "看不清前路的时候，就先跑起来。",
    synopsis: "因伤退役的长跑运动员回到家乡小城，成了中学田径队的临时教练。他要带的是一群没人看好的孩子，也是那个曾经想要放弃的自己。",
    director: "郑向北",
    cast: ["何明川", "董桐", "吴亦扬"],
    status: "正片可观看 · 高清",
    length: "124 分钟",
    updatedAt: "2026-08-30",
    reviews: [
      {
        author: "体育电影志",
        date: "2026-08-31",
        score: 7.9,
        excerpt: "套路是有的，但胜在真诚。训练蒙太奇和最后的决赛拍得足够热血，看完想去操场跑两圈。",
      },
    ],
  },
  {
    id: "snow-country-letter",
    title: "雪国来信",
    type: "tv",
    genres: ["剧情", "悬疑", "家庭"],
    region: "日本",
    year: 2024,
    rating: 8.1,
    cover: "https://readdy.ai/api/search-image?query=Quiet%20mystery%20drama%20poster%20of%20a%20snow%20covered%20japanese%20village%20with%20a%20single%20warm%20lit%20window%2C%20cool%20navy%20blue%20snow%20tones%20and%20soft%20orange%20lamplight%2C%20serene%20melancholic%20winter%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-13&orientation=portrait",
    tagline: "雪会覆盖一切，除了被写下的字。",
    synopsis: "返乡整理祖母遗物的女子，在阁楼发现一箱从未寄出的信。收信人早已不在人世，而信中描述的往事，正一点点改写整个家族的记忆。",
    director: "中村拓海",
    cast: ["森川奈绪", "高桥圭", "石田惠"],
    status: "全 8 集 · 已完结",
    length: "8 集",
    updatedAt: "2026-08-28",
    reviews: [
      {
        author: "冬日剧单",
        date: "2026-08-29",
        score: 8.2,
        excerpt: "慢节奏但后劲极大，像一杯冷掉的茶，越回味越苦，也越暖。",
      },
    ],
  },
  {
    id: "midnight-clinic",
    title: "午夜诊疗室",
    type: "tv",
    genres: ["医疗", "剧情", "职场"],
    region: "韩国",
    year: 2025,
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%20of%20a%20night%20shift%20hospital%20corridor%20with%20glowing%20blue%20signs%20and%20one%20lit%20exam%20room%20door%2C%20deep%20navy%20palette%20accented%20with%20warm%20orange%2C%20calm%20tense%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-14&orientation=portrait",
    tagline: "深夜的急诊室，收留所有无处安放的疼痛。",
    synopsis: "一家专门接待深夜急症的小诊所，聚集了被大医院淘汰的医生和无处可去的病人。在这里，治愈别人的同时，他们也在缝合自己的裂痕。",
    director: "车承宇",
    cast: ["徐珉俊", "姜荷娜", "吴世妍"],
    status: "全 16 集 · 已完结",
    length: "16 集",
    updatedAt: "2026-08-26",
    reviews: [
      {
        author: "韩剧急诊室",
        date: "2026-08-27",
        score: 8.6,
        excerpt: "医疗细节专业，人情味一点不少。每一集都像一次小型的告别与和解。",
      },
    ],
  },
  {
    id: "beneath-iron-curtain",
    title: "铁幕之下",
    type: "movie",
    genres: ["历史", "战争", "剧情"],
    region: "英国",
    year: 2022,
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Historical%20war%20drama%20poster%20of%20a%20divided%20city%20street%20with%20a%20tall%20watchtower%20in%20cold%20fog%2C%20desaturated%20navy%20grey%20tones%20with%20a%20distant%20orange%20signal%20light%2C%20somber%20restrained%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-15&orientation=portrait",
    tagline: "墙的两边，住着同一种思念。",
    synopsis: "冷战年代，一名翻译官被迫在东西方阵营之间周旋，一封封无法送达的家书成了他唯一的坚持。当信念与亲情站在了对立面，他必须做出选择。",
    director: "Edward Nash",
    cast: ["Thomas Grey", "Ingrid Falk", "Peter Nolan"],
    status: "正片可观看 · 高清",
    length: "152 分钟",
    updatedAt: "2026-08-24",
    reviews: [
      {
        author: "历史片笔记",
        date: "2026-08-25",
        score: 8.7,
        excerpt: "格局宏大却始终扎根于一个人的选择，克制、沉重，也格外动人。",
      },
    ],
  },
  {
    id: "city-edge",
    title: "城市边缘",
    type: "movie",
    genres: ["犯罪", "剧情", "黑色"],
    region: "中国大陆",
    year: 2025,
    rating: 7.6,
    cover: "https://readdy.ai/api/search-image?query=Gritty%20neo%20noir%20crime%20film%20poster%20of%20a%20nighttime%20city%20outskirts%20highway%20with%20a%20single%20car%20headlight%2C%20deep%20navy%20darkness%20pierced%20by%20warm%20orange%20glow%2C%20lonely%20tense%20mood%2C%20minimal%20stylized%20cinematic%20illustration&width=600&height=900&seq=marie-poster-16&orientation=portrait",
    tagline: "越靠近边缘，越看得清人心。",
    synopsis: "一名代驾司机在深夜接到一单反常的长途，乘客的后备箱里藏着不可告人的秘密。一场原本平凡的夜晚，逐渐变成他一生中最漫长的路程。",
    director: "韦嘉树",
    cast: ["孙牧", "殷橙", "雷戈"],
    status: "正片可观看 · 高清",
    length: "116 分钟",
    updatedAt: "2026-08-22",
    reviews: [
      {
        author: "黑色电影扫片",
        date: "2026-08-23",
        score: 7.7,
        excerpt: "小成本但气质难得，夜戏氛围拉满，剧本如果再打磨一轮会更好。",
      },
    ],
  },
  {
    id: "rainy-season",
    title: "雨季不再来",
    type: "tv",
    genres: ["青春", "成长", "校园"],
    region: "中国台湾",
    year: 2023,
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20series%20poster%20of%20teenagers%20cycling%20through%20a%20rainy%20taiwanese%20street%20under%20umbrellas%2C%20soft%20muted%20green%20and%20warm%20orange%20tones%2C%20bittersweet%20youthful%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-17&orientation=portrait",
    tagline: "那年夏天，我们都没学会好好告别。",
    synopsis: "高三那年的雨季格外漫长，五个好友在升学、暗恋与家庭变故中跌跌撞撞。多年后重聚，他们才发现青春从未真正下雨，是眼泪模糊了视线。",
    director: "林佩瑜",
    cast: ["许婧恩", "陈柏宇", "黄以乐"],
    status: "全 12 集 · 已完结",
    length: "12 集",
    updatedAt: "2026-08-20",
    reviews: [
      {
        author: "青春剧图鉴",
        date: "2026-08-21",
        score: 8.3,
        excerpt: "没有刻意煽情，却处处戳心。台剧对青春颗粒感的把握依然在线。",
      },
    ],
  },
  {
    id: "quantum-cage",
    title: "量子囚笼",
    type: "movie",
    genres: ["科幻", "惊悚", "悬疑"],
    region: "美国",
    year: 2024,
    rating: 7.9,
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20thriller%20poster%20of%20a%20person%20trapped%20inside%20a%20glowing%20wireframe%20geometric%20cage%20of%20light%2C%20deep%20navy%20void%20with%20sharp%20orange%20lines%2C%20claustrophobic%20mind%20bending%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-18&orientation=portrait",
    tagline: "逃出去的每一种可能，都被计算过了。",
    synopsis: "顶尖物理学家醒来发现自己被困在一间会不断重组的实验室里，每一次逃脱尝试都会生成一条新的时间线。而当所有分支都被试遍，唯一剩下的出路，可能不是逃出去。",
    director: "Samuel Ortega",
    cast: ["Nate Rivera", "Lydia Chen", "Omar Aziz"],
    status: "正片可观看 · 4K",
    length: "119 分钟",
    updatedAt: "2026-08-18",
    reviews: [
      {
        author: "烧脑片研究所",
        date: "2026-08-19",
        score: 8.0,
        excerpt: "概念很酷，执行也基本到位。适合喜欢一边看一边暂停画时间线的人。",
      },
    ],
  },
  {
    id: "cloud-post-office",
    title: "云上邮局",
    type: "movie",
    genres: ["奇幻", "温情", "剧情"],
    region: "日本",
    year: 2023,
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20film%20poster%20of%20a%20tiny%20post%20office%20perched%20on%20floating%20clouds%20above%20a%20sea%20of%20sunset%20orange%20light%2C%20deep%20indigo%20sky%2C%20dreamy%20gentle%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-19&orientation=portrait",
    tagline: "寄不出去的话，云会替你收着。",
    synopsis: "一家开在云朵上的邮局，专门收留那些来不及说出口的话。年轻的邮差负责把它们送往正确的收件人，直到有一天，他收到了一封写给自己的信。",
    director: "宫本周平",
    cast: ["菅原悠", "西村真帆", "大野陆"],
    status: "正片可观看 · 高清",
    length: "108 分钟",
    updatedAt: "2026-08-16",
    reviews: [
      {
        author: "治愈系电影铺",
        date: "2026-08-17",
        score: 8.5,
        excerpt: "温柔到骨子里。看完想给很久没联系的人发条消息。",
      },
    ],
  },
  {
    id: "train-home",
    title: "归途列车",
    type: "tv",
    genres: ["家庭", "剧情", "社会"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Moving%20family%20drama%20series%20poster%20of%20a%20long%20green%20train%20crossing%20snowy%20fields%20at%20dusk%2C%20warm%20orange%20windows%20against%20deep%20navy%20winter%20sky%2C%20wistful%20homecoming%20mood%2C%20minimal%20stylized%20illustration&width=600&height=900&seq=marie-poster-20&orientation=portrait",
    tagline: "无论走多远，总有一站叫回家。",
    synopsis: "一列横跨三千公里的绿皮火车上，八个陌生人因一次意外的延误被迫共度三天两夜。他们带着各自的逃离与牵挂，在摇晃的车厢里交换了半生故事。",
    director: "夏沐阳",
    cast: ["崔嘉树", "袁小满", "海青", "房明"],
    status: "全 20 集 · 已完结",
    length: "20 集",
    updatedAt: "2026-08-14",
    reviews: [
      {
        author: "现实题材剧评",
        date: "2026-08-15",
        score: 8.4,
        excerpt: "群像塑造扎实，车厢就是一个小社会。台词朴实，后劲十足。",
      },
    ],
  },
];

export const regions = ["中国大陆", "中国台湾", "美国", "日本", "韩国", "英国", "法国"];

export const years = [2025, 2024, 2023, 2022, 2021];

export const genreOptions: Record<"movie" | "tv", string[]> = {
  movie: ["犯罪", "悬疑", "科幻", "剧情", "爱情", "奇幻", "动画", "历史", "惊悚", "冒险"],
  tv: ["悬疑", "犯罪", "剧情", "爱情", "都市", "科幻", "医疗", "青春", "家庭", "职场"],
};